import type { GroupingFeedbackSchemaType } from '@vedalib/editor/lib/brand'
import lodash from 'lodash'

import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import type { ElementFeedbackCss } from 'services/Branding/types'

import * as s from './Mask.module.scss'

interface IMaskProps {
  isCorrect?: boolean
  borderRadius?: string | number
  feedback: ElementFeedbackCss<GroupingFeedbackSchemaType>
}

const Mask = ({ isCorrect, borderRadius, feedback }: IMaskProps) => {
  const variant = isCorrect ? feedback?.correct : feedback?.incorrect
  const commonStyle = {
    ...lodash.omit(feedback?.common__var, 'marginRight'),
    ...feedback?.common__var,
  }

  const iconStyle = {
    backgroundImage: variant?.backgroundImage,
    backgroundColor: variant?.backgroundColor,
    color: variant?.color,
    ...commonStyle,
  }

  const content = variant?.backgroundImage ? (
    <div className={s.icon} style={iconStyle} />
  ) : (
    <div className={s.icon} style={iconStyle}>
      <Icon name={isCorrect ? 'success' : 'error'} size={KitSize.S} />
    </div>
  )

  return (
    <div className={s.mask} style={{ borderRadius }}>
      {content}
    </div>
  )
}

export default Mask
